import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AddEditModalGeneric } from '../../../../ui/generics';
import { AddEditEventFormComponent } from '../../forms/add-edit-event-form/add-edit-event-form.component';
import { IEvent, ISeminar } from '../../core/interfaces';

@Component({
    selector: 'app-add-edit-event-modal',
    templateUrl: './add-edit-event-modal.component.html',
    styleUrls: ['./add-edit-event-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddEditEventModalComponent extends AddEditModalGeneric<IEvent, AddEditEventFormComponent> implements OnInit {

  @Input() seminar: ISeminar;

  public constructor(
    protected cdr: ChangeDetectorRef
  ) {
    super(cdr);
  }
}
